import { api } from 'API';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/consumEquip';
const availableItemsUrl = 'consumequip/available';

export interface IEquipmentItem {
  itemCatalogNumber: number;
  itemName: string;
  quantity: number;
  itemNote: string;
  quantityNote?: string;
  maxAVGQuantityPerMonth: number;
  lastOrderOfThatItem?: Date;
  isActive: boolean;
}

export interface IEquipmentCreateOrder {
  note?: string;
  startDate?: Date;
  endDate?: Date;
  orderItems: IEquipmentItem[];
}

export interface IEquipmentAvailableItems {
  caseNumber: string;
  items: IEquipmentItem[];
}

export const createOrder = async (body: IEquipmentCreateOrder) => {
  const newOrder = await api.post<IEquipmentCreateOrder[]>(
    addImposterToUrl(baseUrl, true),
    body
  );

  if (newOrder.status === HTTP_STATUS_CODES.Forbidden) return;
  if (newOrder.data) {
    return newOrder.data;
  }
};

export const getAvailableItems = async () => {
  const availableItems = await api.get<IEquipmentAvailableItems>(
    addImposterToUrl(availableItemsUrl, true)
  );
  if (availableItems.data) {
    return availableItems.data;
  }
};
